import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {geoUtils} from '../utils/geo-utils';

class StateCountyHovers extends Component {

  shouldComponentUpdate(nextProps) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const stateDifferent = nextProps.stateFips !== this.props.stateFips;

    return widthDifferent || heightDifferent || stateDifferent;
  }

  render() {
    const paths = geoUtils.getMercatorStateCountyPaths(this.props.stateFips, this.props.width, this.props.height);

    const getHandlers = county => {
      const onClick = this.props.onClick;
      const onHoverOver = this.props.onHoverOver;
      const onHoverOut = this.props.onHoverOut;
      const handlers = {};

      if (onClick) {
        handlers.onClick = () => onClick(county.stateFips, county.countyFips);
      }

      if (onHoverOver) {
        handlers.onMouseEnter = () => onHoverOver(county.countyFips, county.cent);

        if (onHoverOut) {
          handlers.onMouseOut = () => onHoverOut(county.countyFips);
        }
        else {
          handlers.onMouseOut = () => onHoverOver(null);
        }
      }

      return handlers;
    };

    return (
      <g className="StateCountyHovers">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              id={`FIPS_${d.id}`}
              className="hover_out"
              d={d.path}
              {...getHandlers(d)}
            ></path>
          )
        })}
      </g>
    )
  }
}

StateCountyHovers.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  stateFips: PropTypes.number,
  onHoverOver: PropTypes.func,
  onHoverOut: PropTypes.func,
  onClick: PropTypes.func,
};


export default StateCountyHovers


// WEBPACK FOOTER //
// ./src/charts/Map/StateCountyHovers.js